import { useSelector } from 'react-redux';

export const useLandingPageLanguageSelector = () => useSelector(state => state.settings.landingPageLanguage);
export const fontSizeSelector = state => state.settings.styles.fontSize;
export const siteModeSelector = state => state.settings.styles.siteMode;
export const stylesSelector = state => state.settings.styles;
export const defaultPageSelector = state => state.settings.defaultPage;
export const isFilteredDataSelector = state => state.settings.isFilteredData;
export const tableColumnsListSelector = state => state.settings.tableColumnsList;
